import { IOExtensionType, } from 'z3k-parser/model/device-spec/type';
export const device_specs = DEVICE_SPEC ??
    //@ts-ignore
    global.DEVICE_SPEC;
export const builtin_extension_specs = BUILTIN_EXTENSIONS_SPEC ??
    //@ts-ignore
    global.BUILTIN_EXTENSIONS_SPEC;
export const extension_specs = EXTENSIONS_SPEC ??
    //@ts-ignore
    global.EXTENSIONS_SPEC;
